import { render, staticRenderFns } from "./TrainingVideos.vue?vue&type=template&id=15dd22c4&scoped=true&"
import script from "./TrainingVideos.vue?vue&type=script&lang=js&"
export * from "./TrainingVideos.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideos.vue?vue&type=style&index=0&id=15dd22c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd22c4",
  null
  
)

export default component.exports